import TenantProfileEdit from "../../../Boilerplate/Tenants/TenantProfileEdit";
import { useMarketplaces } from "../_Shared/useMarketplaces";
import {
  creditTypeLabel,
  creditsToSkus,
  destinationName,
  isSponsoredCreditType,
} from "../utils/skus";
import { useStore } from "../store";

export default function TenantSettings() {
  const tenantProfile = useStore((state) => state.tenantProfile);
  const { marketplaces } = useMarketplaces();
  const dest = destinationName(tenantProfile, marketplaces);

  return (
    <TenantProfileEdit
      showSubscription={false}
      allowCreditsWithoutPlan={true}
      formatCreditTotal={(credit) => {
        const sponsored = isSponsoredCreditType(credit.creditType);
        const name =
          dest ||
          creditTypeLabel(credit.creditType, marketplaces).replace(
            / trial SKUs$/,
            "",
          );
        return {
          label: creditTypeLabel(credit.creditType, marketplaces),
          value: creditsToSkus(credit.creditsLeft),
          suffix: "SKUs",
          description: sponsored
            ? `From ${name}. Only pay for ${name} listings.`
            : "Paid SKUs. Use on any marketplace.",
        };
      }}
    />
  );
}
